import { useState } from "react";
import {
  Grid,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemButton,
} from "@mui/material";

import DeploymentDialog from "./DeploymentDialog";

const Deployments = ({ deployments, refresh }) => {
  const [selectedDeployment, setSelectedDeployment] = useState(null);

  return (
    <Paper elevation={3} style={{ width: "100%", height: 300, padding: 10 }}>
      <Grid container direction="column">
        <Grid item>
          <Typography variant="h5">Sites</Typography>
        </Grid>
        <Grid item>
          <List
            style={{
              maxHeight: 200,
              overflowY: "scroll",
              marginBottom: 10,
            }}
          >
            {deployments.map((deployment) => {
              return (
                <ListItem key={deployment._id}>
                  <ListItemButton
                    onClick={() => setSelectedDeployment(deployment)}
                  >
                    {deployment.siteUrl}
                  </ListItemButton>
                </ListItem>
              );
            })}
          </List>
        </Grid>
      </Grid>
      <DeploymentDialog
        deployment={selectedDeployment}
        close={() => {
          refresh();
          setSelectedDeployment(null);
        }
      }
      />
    </Paper>
  );
};

export default Deployments;
